import React, { FC } from 'react';

interface IProps {}

export const HasNotPermissions: FC<IProps> = (props) => {
  return <h3 className="ml20 font-roboto">Разрешение на доступ к разделу отсутствует, обратитесь к администратору.</h3>;
};
